/*
 * Old Mountain Tea — footer language + currency selectors.
 *
 *  1. Submits the native Shopify localization form when a shopper picks a
 *     language or currency from the footer dropdowns.
 *  2. On a shopper's FIRST visit only, reads their browser locale
 *     (navigator.language, e.g. "fr-FR") and, if it maps to an enabled
 *     language/currency that differs from what's currently shown, switches
 *     automatically to match their location. A flag in localStorage makes this
 *     a one-time action, so a shopper's later manual choice is never overridden.
 */
(function () {
  'use strict';

  var FLAG = 'omt-loc-auto-v1';
  var root = document.querySelector('.omt-loc[data-current-lang]');
  if (!root) return;

  function markChosen() {
    try { localStorage.setItem(FLAG, '1'); } catch (e) {}
  }

  // --- Manual selection: submit the relevant localization form on change. ---
  var selects = root.querySelectorAll('select[name="language_code"], select[name="country_code"]');
  for (var i = 0; i < selects.length; i++) {
    selects[i].addEventListener('change', function (e) {
      markChosen(); // a deliberate choice — stop auto-switching from now on
      if (e.target.form) e.target.form.submit();
    });
  }

  // --- Auto-switch by location: runs once, only if nothing chosen yet. ---
  var already;
  try { already = localStorage.getItem(FLAG); } catch (e) { already = null; }
  if (already) return;

  var nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
  if (!nav) { markChosen(); return; }

  var parts = nav.split('-');
  var langMap = { fr: 'fr', de: 'de', en: 'en', es: 'es', it: 'it', pt: 'pt-BR', pl: 'pl', ja: 'ja', ko: 'ko', cs: 'cs' };
  var wantLang = langMap[parts[0]] || null;
  var wantCountry = parts[1] ? parts[1].toUpperCase() : null;

  function csv(attr) {
    return (root.getAttribute(attr) || '').split(',').filter(Boolean);
  }
  var availLangs = csv('data-avail-langs');
  var availCountries = csv('data-avail-countries');
  var curLang = root.getAttribute('data-current-lang');
  var curCountry = root.getAttribute('data-current-country');

  var changeLang = wantLang && availLangs.indexOf(wantLang) > -1 && wantLang !== curLang;
  var changeCountry = wantCountry && availCountries.indexOf(wantCountry) > -1 && wantCountry !== curCountry;

  if (!changeLang && !changeCountry) { markChosen(); return; }

  var form = document.getElementById('omt-auto-loc');
  if (!form) { markChosen(); return; }

  if (changeLang) {
    var langInput = form.querySelector('[data-omt-auto-lang]');
    if (langInput) langInput.value = wantLang;
  }
  if (changeCountry) {
    var countryInput = form.querySelector('[data-omt-auto-country]');
    if (countryInput) countryInput.value = wantCountry;
  }

  markChosen(); // set the flag BEFORE submitting so a reload can't loop
  form.submit();
})();
